'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "usePreventZoomTransitionDismissal", {
    enumerable: true,
    get: function() {
        return usePreventZoomTransitionDismissal;
    }
});
function usePreventZoomTransitionDismissal(_options) {
// No-op on non-iOS platforms
}

//# sourceMappingURL=usePreventZoomTransitionDismissal.js.map
